import Service from "../../AuthService";

const Invoice = {
    getInvoice(page) {
        return Service.get("/invoice?page="+page);
    },
    showInvoice(id) {
        return Service.get("/invoice/" + id);
    },
    updateInvoice(id, data) {
        return Service.put("/invoice/" + id, data);
    },
    createInvoice(data) {
        return Service.post("/invoice", data);
    },
    deleteInvoice(id) {
        return Service.delete("/invoice/" + id);
    },
    filterInvoice(page,status) {
        return Service.get("invoice-filter?page=" + page +
            "&status=" + status);
    },
    searchInvoice(page,search) {
        console.log(search);
        return Service.post("/invoice-search?page="+page , search);
    },
    checkInvoiceFromDriver(driver_id){
        return Service.get("/invoice-driver?driver_id="+driver_id);
    },
    PromotionInvoice(data){
        return Service.post("/invoice-promotion",data);
    },
    PromotionInvoiceMultiple(data){
        return Service.post("/invoice-promotion-multiple",data);
    },
    selectInvoiceAll(data){
        console.log("/selectInvoiceAll",data);
        return Service.post("/selectInvoiceAll",data);
    },
    getInvoiceAll(){
        return Service.get("/get-all-invoice");
    },
    approveInvoiceEdit(id){
        return Service.get("/approve-invoice-edit/"+id);
    },
    getInvoiceTransportPrice(form){
        return Service.post("/invoice_transport_price",form);
    },
    changeInvoiceStatus(data){
      return Service.post('/change_status_invoice',data)
    },
    reportInvoice(data){
        return Service.get("/invoice-report?start_date="+data.start_date+
            "&end_date="+data.end_date+
            "&customer_id="+data.customer_id+
            "&sale_id="+data.sale_id
        )
    },
    countReportInvoice(data){
        return Service.get("/invoice-report-count?start_date="+data.start_date+
            "&end_date="+data.end_date+
            "&customer_id="+data.customer_id+
            "&sale_id="+data.sale_id)
    },
    printPromotionInvoiceReport(data){
        return Service.get("/invoice-promotion-report?start_date="+data.start_date+
            "&end_date="+data.end_date+
            "&sale_id="+data.sale_id+
            "&customer_id="+data.customer_id)
    },
    //save invoice save&print
    updateInvoicePDF(id, data) {
        return Service.put("/invoice-pdf/" + id, data);
    },
    createInvoicePDF(data) {
        return Service.post("/invoice-pdf", data);
    },
    generateTN(){
        return Service.get('generate_tn_number');
    },
    getInvoiceByCustomerId(data){
        return Service.get('get_invoice_by_customer?customer_id='+data.customer_id);
    },
    updateInvoiceDriver(data){
        return Service.post('/update_driver_invoice',data)
    },
    printMultiInvoice(id){
        return Service.get('/merge/invoice_merge_pdf?id='+id);
    },

};

export default Invoice;
